import React from 'react';
import { PublicThemeProvider } from '../../contexts/PublicThemeContext';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import AnimatedBackground from '../../shared/components/AnimatedBackground/AnimatedBackground';
import './PublicLayout.css';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <PublicThemeProvider>
      <div className="public-layout">
        <AnimatedBackground />
        <Navbar />
        <main className="public-main">
          {children}
        </main>
        <Footer />
      </div>
    </PublicThemeProvider>
  );
};

export default PublicLayout;

